import * as React from 'react';

import Logo from 'components/logo/Logo';

import type { LogoProps } from 'components/logo/Logo';

type Props = {
  children?: React.ReactNode,
  logoProps?: LogoProps
};


const BasicHeaderWithLogo = ({
  children,
  logoProps
}: Props) => (
  <header className="header">
    <div className="header__container">
      <div className="layout-container">
        <div className="header__inner">
          <Logo {...logoProps} />
          {children}
        </div>
      </div>
    </div>
  </header>
);

export default BasicHeaderWithLogo;
